export default __webpack_public_path__ + "static/media/route-1.d4c8f2df.png";